import { render } from "./Landing-Page.vue?vue&type=template&id=677ae301&scoped=true"
import script from "./Landing-Page.vue?vue&type=script&lang=js"
export * from "./Landing-Page.vue?vue&type=script&lang=js"

import "./Landing-Page.vue?vue&type=style&index=0&id=677ae301&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-677ae301"]])

export default __exports__